import type { QBankStructureLevel } from '@exam-management/qbs-provider';

import type { QBSLevelItemExcludingTag } from '../types';

import { findLastOrderBySiblings } from './order';

export function changeQBankStructureLevelItemToNonInfoItem(
  targetLevelItemId: string,
  levelItems: QBSLevelItemExcludingTag[],
  qBankStructureLevels: QBankStructureLevel[],
) {
  const updatedLevelItems: QBSLevelItemExcludingTag[] = [];
  const maxLevel = Math.max(...qBankStructureLevels.map((item) => item.level));

  const targetLevelItem = levelItems.find((item) => {
    return item.id === targetLevelItemId;
  });
  if (!targetLevelItem) {
    return null;
  }

  for (const levelItem of levelItems) {
    if (targetLevelItem.parentLevelItemId !== levelItem.parentLevelItemId) {
      updatedLevelItems.push(levelItem);
      continue;
    }
    if (levelItem.order === 0) {
      return null;
    }

    if (levelItem.id === targetLevelItemId) {
      if (levelItem.qBankStructureLevel.level === maxLevel) {
        return null;
      }
      updatedLevelItems.push({
        ...levelItem,
        order: 0,
      });
      continue;
    }

    if (targetLevelItem.order < levelItem.order) {
      updatedLevelItems.push({
        ...levelItem,
        order: levelItem.order - 1,
      });
    } else {
      updatedLevelItems.push(levelItem);
    }
  }

  return updatedLevelItems;
}

export function changeQBankStructureLevelItemToInfoItem(
  targetLevelItemId: string,
  levelItems: QBSLevelItemExcludingTag[],
) {
  const targetLevelItem = levelItems.find((item) => {
    return item.id === targetLevelItemId;
  });
  if (!targetLevelItem || targetLevelItem.order !== 0) {
    return levelItems;
  }

  const newOrder = findLastOrderBySiblings(levelItems, targetLevelItem.parentLevelItemId) + 1;

  const updatedLevelItems = levelItems.filter((item) => {
    return item.id !== targetLevelItemId;
  });

  return [
    ...updatedLevelItems,
    {
      ...targetLevelItem,
      order: newOrder,
    },
  ];
}
